import cx from 'classnames'

import { logEvent } from 'lib/analytics'
import { ROUTE_PATH } from 'lib/paths'
import { User } from 'lib/_types'

import Avatar from 'components/Avatar'
import { Link } from 'features/i18n/router'

import './style.scss'

type Props = {
  user: Partial<User>
  isConversationLayoutSmall?: boolean
  isGroupPost?: boolean
  onClick?: () => void
}

const PostAvatar = ({
  user,
  isConversationLayoutSmall,
  isGroupPost,
  onClick,
}: Props) => {
  return (
    <div
      className={cx('PostAvatar', {
        'PostAvatar--conversation': isConversationLayoutSmall,
      })}
    >
      <Link
        to={ROUTE_PATH.USER(user?.id)}
        className={cx('PostAvatar__a', {
          'PostAvatar__a--small': isConversationLayoutSmall,
        })}
        onClick={() => {
          logEvent.user_profile_open({
            target_user_id: user?.id.toString(),
            from: isGroupPost ? 'group_post_user' : 'post_user',
          })

          onClick?.()
        }}
      >
        <Avatar user={user} className="PostAvatar__image" />
      </Link>
    </div>
  )
}

export default PostAvatar
